const bodyWidth = document.body.clientWidth || document.documentElement.clientWidth;
// const dev = process.env.NODE_ENV;
const urls = window.location.hostname.split (".");
const last = urls[urls.length - 1];
console.log ({ "process.env.BUILD_ENV": process.env.BUILD_ENV, "process.env.NODE_ENV": process.env.NODE_ENV }, last);
const config = {
  sid: 2,
  ratio: bodyWidth / 1200,
  USER_REGISTER_TYPE_SHOP: 14,
  // host: "quanmaikeji.cn",//测试
  host: last === "cloud" ? "quanmai.cloud" : "quanmaikeji.cn",//关联易商易客
};
export default config;
